export default __webpack_public_path__ + "static/media/logo_2020_w.ade7216b.png";